import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from "../../../util/lodash";
import cx from 'classnames';
import Animate from "../animate";
import Button from "../../core/button";
import Icon from "../../core/icon";
import WizardCrumb from "./wizard-crumb";
import { icons, sizes } from "../../../enums";

var Wizard = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Wizard, _Component);

  function Wizard(props) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7;

    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      activeStepIndex: 0,
      isNextDisabled: true,
      isPreviousDisabled: true,
      crumbPositions: [],
      movingBack: false
    };
    _this.moveTo = _bindInstanceProperty(_context = _this.moveTo).call(_context, _assertThisInitialized(_this));
    _this.moveFirst = _bindInstanceProperty(_context2 = _this.moveFirst).call(_context2, _assertThisInitialized(_this));
    _this.moveLast = _bindInstanceProperty(_context3 = _this.moveLast).call(_context3, _assertThisInitialized(_this));
    _this.moveNext = _bindInstanceProperty(_context4 = _this.moveNext).call(_context4, _assertThisInitialized(_this));
    _this.movePrevious = _bindInstanceProperty(_context5 = _this.movePrevious).call(_context5, _assertThisInitialized(_this));
    _this.getCrumbPositions = _bindInstanceProperty(_context6 = _this.getCrumbPositions).call(_context6, _assertThisInitialized(_this));
    _this.handleWindowResize = _.debounce(_bindInstanceProperty(_context7 = _this.handleWindowResize).call(_context7, _assertThisInitialized(_this)), 200);
    return _this;
  }

  var _proto = Wizard.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  };

  _proto.componentDidMount = function componentDidMount() {
    this.moveTo(0);
    this.getCrumbPositions();
    window.addEventListener('resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.getCrumbPositions();
  };

  _proto.getCrumbPositions = function getCrumbPositions() {
    var _this2 = this;

    this.setState(function () {
      return {
        crumbPositions: _this2.props.crumbs === true ? _mapInstanceProperty(_).call(_, _this2.crumbWrapper.children, function (c) {
          return c.offsetLeft;
        }) : []
      };
    });
  } // are we allowed to move forward?
  ;

  _proto.canProceed = function canProceed(movingBack) {
    this.setState(function () {
      return {
        movingBack: movingBack
      };
    });
    return true;
  } // this should allow us to do async validation later...in theory
  ;

  _proto.abstractCanProceedToPromise = function abstractCanProceedToPromise(movingBack) {
    return _Promise.resolve(this.canProceed(movingBack));
  } // update the currently active step on state
  ;

  _proto.updateActiveStep = function updateActiveStep(step) {
    if (step === void 0) {
      step = 0;
    }

    this.setState(function () {
      return {
        activeStepIndex: step
      };
    });
  } // update the navigation button state
  ;

  _proto.updateNavState = function updateNavState(step) {
    var _this3 = this;

    this.setState(function () {
      return {
        isNextDisabled: step === _this3.props.steps.length - 1,
        isPreviousDisabled: step === 0
      };
    });
  } // move to a passed step.
  ;

  _proto.move = function move(to, movingBack) {
    var _this4 = this;

    this.abstractCanProceedToPromise(movingBack).then(function (proceed) {
      if (proceed === void 0) {
        proceed = true;
      }

      if (proceed) {
        _this4.updateActiveStep(to);

        _this4.updateNavState(to);
      }
    });
  };

  _proto.moveTo = function moveTo(to) {
    this.move(to, to < this.state.activeStepIndex);
  };

  _proto.moveFirst = function moveFirst() {
    this.move(0, true);
  };

  _proto.moveLast = function moveLast() {
    this.move(this.props.steps.length - 1);
  };

  _proto.moveNext = function moveNext() {
    this.move(this.state.activeStepIndex + 1);
  };

  _proto.movePrevious = function movePrevious() {
    this.move(this.state.activeStepIndex - 1, true);
  } // build the animation config based on the direction of travel
  ;

  _proto.getAnimationConfig = function getAnimationConfig() {
    return {
      enterAnimation: {
        animation: "transition.slide" + (this.state.movingBack ? 'Left' : 'Right') + "BigIn",
        duration: 250,
        delay: 300
      },
      leaveAnimation: {
        animation: "transition.slide" + (this.state.movingBack ? 'Right' : 'Left') + "BigOut",
        duration: 250
      }
    };
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this$state = this.state,
        activeStepIndex = _this$state.activeStepIndex,
        isPreviousDisabled = _this$state.isPreviousDisabled,
        isNextDisabled = _this$state.isNextDisabled;
    var _this$props = this.props,
        steps = _this$props.steps,
        showNav = _this$props.showNav;
    var activeStep = steps[activeStepIndex];

    var _cls = cx('ck wizard-ui', {
      hasNav: showNav,
      hasToolbar: this.props.toolbar,
      inverted: this.context.isInverted
    });

    var _this$getAnimationCon = this.getAnimationConfig(),
        enterAnimation = _this$getAnimationCon.enterAnimation,
        leaveAnimation = _this$getAnimationCon.leaveAnimation;

    return /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, this.props.toolbar ? /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-toolbar"
    }, this.props.toolbar) : null, /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-body"
    }, showNav ? /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-navigation wizard-ui-navigation__button-previous"
    }, /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      onClick: this.movePrevious,
      isDisabled: isPreviousDisabled,
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: icons.ARROW_PREVIOUS,
        size: sizes.X8
      })
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-step__wrapper"
    }, /*#__PURE__*/React.createElement(Animate.OnMountChange, {
      className: "wizard-ui-step__inner",
      onMountAnimation: enterAnimation,
      onUnmountAnimation: leaveAnimation
    }, /*#__PURE__*/React.cloneElement(activeStep({
      moveTo: this.moveTo,
      moveNext: this.moveNext,
      movePrevious: this.movePrevious,
      moveFirst: this.moveFirst,
      moveLast: this.moveLast
    }), {
      key: activeStepIndex
    }))), showNav ? /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-navigation wizard-ui-navigation__button-next"
    }, /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      onClick: this.moveNext,
      isDisabled: isNextDisabled,
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: icons.ARROW_NEXT,
        size: sizes.X8
      })
    })) : null), /*#__PURE__*/React.isValidElement(this.props.crumbs) ? /*#__PURE__*/React.cloneElement(this.props.crumbs, {
      activeStepIndex: activeStepIndex
    }) : !!this.props.crumbs ? /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-crumbs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-crumbs__crumb-current",
      style: {
        left: this.state.crumbPositions[activeStepIndex] || 0
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icons.PACMAN,
      size: sizes.X6
    })), /*#__PURE__*/React.createElement("div", {
      className: "wizard-ui-crumbs__inner",
      ref: function ref(crumbWrapper) {
        _this5.crumbWrapper = crumbWrapper;
      }
    }, _mapInstanceProperty(steps).call(steps, function (step, idx) {
      return /*#__PURE__*/React.createElement(WizardCrumb, {
        key: idx,
        index: idx,
        active: activeStepIndex === idx,
        hidden: activeStepIndex >= idx
      });
    }, this))) : null);
  };

  return Wizard;
}(Component);

Wizard.displayName = 'Wizard';
Wizard.propTypes = {
  showNav: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.func).isRequired,
  toolbar: PropTypes.element,
  crumbs: PropTypes.oneOfType([PropTypes.element, PropTypes.bool])
};
Wizard.defaultProps = {
  showNav: true,
  crumbs: true
};
Wizard.contextTypes = {
  isInverted: PropTypes.bool
};
export default Wizard;
/*
 TODO:
 - can we have an invalid class on the Wizard.Step so we can style there too?
 */
//# sourceMappingURL=wizard.js.map